import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, filename: String }

  connect() {
    this.isDownloading = false
  }

  download(event) {
    event.preventDefault()

    // Prevent multiple clicks during download
    if (this.isDownloading) {
      return
    }

    if (this.urlValue) {
      this.isDownloading = true

      // Show loading state
      this.showLoading()

      // Make a fetch request to download the file
      fetch(this.urlValue, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/octet-stream'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Download failed')
        }
        return response.blob()
      })
      .then(blob => {
        // Create download link
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.filenameValue || 'media'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
      .catch(error => {
        console.error('Download error:', error)
        alert('Error al descargar el archivo')
      })
      .finally(() => {
        // Hide loading state and re-enable button
        this.hideLoading()
        this.isDownloading = false
      })
    }
  }

  showLoading() {
    const button = this.element.querySelector('.download-icon, .media-menu-item')
    if (button) {
      // Disable the button completely
      button.disabled = true
      button.style.opacity = '0.6'
      button.style.pointerEvents = 'none'
      button.style.cursor = 'not-allowed'

      // Add loading spinner if it's a button
      if (button.classList.contains('download-icon')) {
        const spinner = document.createElement('div')
        spinner.className = 'download-spinner'
        spinner.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'
        spinner.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #25d366;'
        button.style.position = 'relative'
        button.appendChild(spinner)
      } else if (button.classList.contains('media-menu-item')) {
        // For menu items, change the text to show loading
        const originalText = button.textContent
        button.setAttribute('data-original-text', originalText)
        button.textContent = 'Descargando...'
      }
    }
  }

  hideLoading() {
    const button = this.element.querySelector('.download-icon, .media-menu-item')
    if (button) {
      // Re-enable the button
      button.disabled = false
      button.style.opacity = '1'
      button.style.pointerEvents = 'auto'
      button.style.cursor = 'pointer'

      // Remove loading spinner
      const spinner = button.querySelector('.download-spinner')
      if (spinner) {
        spinner.remove()
      }

      // Restore original text for menu items
      if (button.classList.contains('media-menu-item')) {
        const originalText = button.getAttribute('data-original-text')
        if (originalText) {
          button.textContent = originalText
          button.removeAttribute('data-original-text')
        }
      }
    }
  }
}
